import React, { useEffect, useState, useRef } from 'react';
import { Col, Container, Input, Label, Row, Spinner } from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { v4 as generateUnid } from 'uuid';
import moment from 'moment';
import { Link, Redirect } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import Translate, { t } from '../common/Translate';
import Block from '../common/Display/Block';
import getConcessionsApi from '../../services/Form/getConcessionsApi';
import postRecord from '../../services/Calendar/postRecord';
import createFolderIcon from '../../assets/img/create-folder.svg';
import MenuNavBottom from '../common/MenuNavBottom';
import '../../assets/scss/react-datepicker.css';
import { datesFormat } from '../../config';
import { calendarLang } from '../../language-context';
import { Auth, recordManager } from '../../config/configuration/react';

const configAppointementDate = {
  meetingTime: {
    label: 'meetingTime',
    type: 'select',
    icon: 'icon-chevron-down',
  },
  meetingPointOfSale: {
    label: 'meetingPointOfSale',
    type: 'select',
    icon: 'icon-location',
  },
};

const CreateCalendar = (props) => {
  const date = _.get(props, 'location.state.queries.date', undefined);
  const [queries, setQueries] = useState({
    meetingDate: date || moment(new Date()).format('YYYY-MM-DD'),
    meetingTime: `${moment(new Date()).format('HH')}:00`,
  });
  const [error, setError] = useState(null);
  const [isLoading, setisLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [listConcession, setListConcession] = useState(null);
  const [redirect, setRedirect] = useState(null);
  const [meetingDate, setMeetingDate] = useState(date ? new Date(date) : new Date());
  const times = [];
  const isMounted = useRef(false);
  if (times.length === 0) {
    let i = 0;
    let j = 0;

    for (i = 9; i < 20; i += 1) {
      for (j = 0; j < 1; j += 1) {
        times.push(`${i === 9 ? '09' : i}:${j === 0 ? '00' : 30 * j}`);
      }
    }
  }

  useEffect(() => {
    const {
      location: {
        state: {
          queries: { time, concessionId },
        },
      },
    } = props;
    if (queries) {
      queries.meetingDate = date;
      queries.meetingTime = time;
      queries.meetingPointOfSale = concessionId;
    }
    if (!listConcession) {
      getConcessionsApi().then((concessions) => {
        if (concessions.length > 0 && !queries.meetingPointOfSale) queries.meetingPointOfSale = concessions[0].id;
        if (isMounted.current) return;
        setListConcession(concessions);
      });
    }
  }, []);

  const appLang = Auth.preferredLanguage();
  const validateRefId = async (value) => {
    const refHexa = value;
    if (refHexa) {
      if (!(refHexa.length > 5 && refHexa.length < 8) || !new RegExp(/^[0-9a-fA-F]+$/).test(refHexa)) {
        setError('refHexaId_dont_match');
        return false;
      }
      const { records } = await recordManager.search({ refHexaId: refHexa });
      if (records.length > 0) {
        setError('record_already_exist');
        return false;
      }

      return true;
    }
    return false;
  };
  const generateRefHexaId = () => {
    const uuid1 = generateUnid();
    return uuid1.substring(0, 7).toUpperCase();
  };
  const formatData = () => {
    const vehInfo = {};
    vehInfo.appointmentDateTime = moment(`${queries.meetingDate} ${queries.meetingTime}:00`).format(
      'YYYY-MM-DD HH:mm:ss',
    );
    vehInfo.concessionId = queries.meetingPointOfSale;
    vehInfo.refHexaId = generateRefHexaId();
    vehInfo.refId = parseInt(vehInfo.refHexaId, 16);
    return vehInfo;
  };

  useEffect(() => {
    Object.entries(queries).forEach((querie) => {
      if (querie[1] === '' || querie[1] === '0') {
        delete queries[querie[0]];
        setDisabled(true);
      }
    });
  }, [queries]);

  const handleChange = (e) => {
    setError(false);
    let data = [];
    let { value } = e.target;
    const { id } = e.target;
    value = _.trim(value);
    if (queries) data = { ...queries };
    if (id === 'refHexaId') validateRefId(value);
    data[id] = value;
    setQueries(data);
  };

  const handleCreate = async () => {
    let record;
    setisLoading(true);
    try {
      record = formatData();
      record.status = 18;
      record.origin = 'carcheck';
      const response = await postRecord(record);
      if (response.recordId) setRedirect(`/files/${response.recordId}`);
    } catch (e) {
      setError(e.message);
    } finally {
      if (!isMounted.current) setisLoading(false);
    }
  };

  const handleChangeDate = (id, value) => {
    setQueries((next) => {
      const _next = next;
      if (value === null) {
        delete _next[id];
        return _next;
      }
      const formatDate = moment(value).format('YYYY-MM-DD');
      if (formatDate) _next[id] = formatDate;
      return _next;
    });
    setMeetingDate(value);
  };

  return (
    <Block {...props} backRoute="/calendar">
      <h1 className="page-title">
        <span className="cursor-pointer">
          <img src={createFolderIcon} alt="" height="25" /> {t('create_new_inspection')}
        </span>
      </h1>

      <Container fluid className="mt-4">
        <Row>
          <Col xs="12" sm="6" lg="5" xl="4">
            <Label className="text-primary text-left" for="meetingDate">
              <Translate code="meetingDate" />
            </Label>
            <DatePicker
              className="form-control rounded"
              name="meetingDate"
              id="meetingDate"
              onChange={(e) => handleChangeDate('meetingDate', e)}
              selected={meetingDate}
              locale={calendarLang[appLang]}
              dateFormat={appLang === 'DE' ? datesFormat[appLang] : datesFormat.default}
              placeholderText={t('date_placeholder')}
              autoComplete="off"
            />
          </Col>
        </Row>
        {Object.entries(configAppointementDate).map(([key, i]) => (
          <Row>
            <Col xs="12" sm="6" lg="5" xl="4" key={key}>
              <Label className="text-primary text-left" for={key}>
                <Translate code={i.label} />
              </Label>
              <Input
                className={`form-control rounded ${i.icon}`}
                type={i.type}
                name={key}
                id={key}
                onChange={(e) => handleChange(e)}
                placeholder={i.placeholder}
              >
                {['meetingTime', 'meetingPointOfSale'].includes(key) && <option value="0">{`${t('select')}`}</option>}
                {key === 'meetingPointOfSale' &&
                  listConcession &&
                  listConcession.map((concession) => (
                    <option
                      key={concession.id}
                      value={concession.id}
                      selected={
                        queries.meetingPointOfSale && queries.meetingPointOfSale === concession.id ? 'selected' : ''
                      }
                    >
                      {concession.name}
                    </option>
                  ))}
                {key === 'meetingTime' &&
                  times.map(
                    (time) =>
                      `${queries.meetingDate} ${time}` >
                        `${moment().subtract(1, 'hours').format('YYYY-MM-DD HH')}:00` && (
                        <option key={time} value={time} selected={queries.meetingTime === time ? 'selected' : ''}>
                          {time}
                        </option>
                      ),
                  )}
              </Input>
            </Col>
          </Row>
        ))}

        {error && (
          <p className="ml-2 text-danger">
            <Translate code={error} />
          </p>
        )}
        <Row>
          <Col xs="12" sm="6" lg="5" xl="4">
            <button
              className="btn btn-orange btn-block mb-3 text-uppercase"
              onClick={handleCreate}
              disabled={!(!disabled && !error)}
              type="button"
            >
              {isLoading && <Spinner size="sm" />}
              {t('create_folder')}
            </button>
          </Col>
        </Row>
        <Row>
          <Col xs="12" sm="6" lg="5" xl="4" className="text-center">
            <Link to="/calendar" className="btn btn-outline-secondary btn-block">
              {t('back_to_calendar')}
            </Link>
          </Col>
        </Row>
        {redirect && (
          <Redirect
            to={{
              pathname: redirect,
            }}
          />
        )}
      </Container>
      <MenuNavBottom active="createFolder" />
    </Block>
  );
};

export default CreateCalendar;

CreateCalendar.propTypes = {
  location: PropTypes.shape().isRequired,
};
